module.exports = __webpack_public_path__ + "img/question-circle-regular-white.665251c4.svg";